import React from "react";
import MasterComponent from "../../../../components/Forms";
import { MasterConfigs } from "../../../../interfaces/entity";

const NoticePeriod = () => {

    const config: MasterConfigs = {
        api: () => '/notice-period',
        title: 'Notice Period',
        modalTitle: () => config.title,
        getColumns: () => [
            {
                title: 'Name',
                dataIndex: 'name',
                key: 'name',
            },
            {
                title: 'Code',
                dataIndex: 'code',
                key: 'code',
            },
            {
                title: 'Notice Period Duration',
                dataIndex: 'noticePeriodDuration',
                key: 'noticePeriodDuration',
                render: (text, record) => `${record.noticePeriodDuration} ${record.noticePeriodDurationType}`
            },
            {
                title: 'Description',
                dataIndex: 'description',
                key: 'description',
                width: '50%',
                ellipsis: true
            },
            {
                title: 'Status',
                dataIndex: 'status',
                key: 'status',
            }
        ],
        getFormColumns: () => [
            {
                label: 'Name',
                name: 'name',
                type: 'text',
                rules: [{ required: true, message: 'Please enter name' }]
            },
            {
                label: 'Code',
                name: 'code',
                type: 'text',
                rules: [{ required: true, message: 'Please enter Code' }]
            },
            {
                label: 'Description',
                name: 'description',
                type: 'textarea',
                span: 16
            },
            {
                span: 8,
            },
            {
                label: 'Notice Period Duration',
                name: 'noticePeriodDuration',
                type: 'number',
                rules: [{ required: true, message: 'Please enter notice period duration' }]
            },
            {
                label: 'Notice Period Duration Type',
                name: 'noticePeriodDurationType',
                type: 'select',
                children: [
                    { name: 'Months', value: 'Months' },
                    { name: 'Days', value: 'Days' }
                ],
                rules: [{ required: true, message: 'Please select duration type' }]
            },
        ],
        isActionTab: true,
        actions: [{ actionType: 'Add', name: 'Add' }]
    }

    return <MasterComponent config={config} />
}

export default NoticePeriod;